import React, { useState, useEffect } from "react";
import TimePicker from "rc-time-picker";
import moment from "moment";
import { connect } from "react-redux";
import { loader } from "../../Actions/index";
import store from "../../store";
import "rc-time-picker/assets/index.css";
import { ToastSuccess, ToastError } from "../../component/toast-notification";
import { CreateDeHub, getOwner, getHub, UpdateDeHub, UpdateDeHubImage, uploadImage, allSearch, GetSingleDeHub } from "../../api/apiService";

const mapStateToProps = (store) => {
    return {
        loaderDisplay: store.loaderDisplay,
    };
};

const DeHubForm = (props) => {
    const [isUpdate, setIsUpdate] = useState(false);
    const hubId = new URLSearchParams(props.location.search).get("hubId");

    // Individual state variables
    const [singleDeHubDetails, setSingleDeHubDetails] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [ownerSelect, setOwnerSelect] = useState("");
    const [imageOne, setImageOne] = useState(null);
    const [hubImg, setHubImg] = useState(null);
    const [imageTwo, setImageTwo] = useState(null);
    const [addvertiseImg, setAddvertiseImg] = useState(null);
    const [hubName, setHubName] = useState("");
    const [brandName, setBrandName] = useState("");
    const [fssaiNo, setFssaiNo] = useState("");
    const [licenceNo, setLicenceNo] = useState("");
    const [gstNo, setGstNo] = useState("");
    const [landmark, setLandmark] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [locality, setLocality] = useState("");
    const [description, setDescription] = useState("");
    const [hubAddress, setHubAddress] = useState("");
    const [addMapLat, setAddMapLat] = useState("");
    const [addMapLong, setAddMapLong] = useState("");
    const [openTime, setOpenTime] = useState(moment());
    const [closeTime, setCloseTime] = useState(moment());
    const [breakStart, setBreakStart] = useState(moment());
    const [breakEnd, setBreakEnd] = useState(moment());
    const [pinNo, setPinNo] = useState("");
    const [startTime, setStartTime] = useState(moment());
    const [endTime, setEndTime] = useState(moment());
    const [headerText, setHeaderText] = useState("");
    const [footerText, setFooterText] = useState("");
    const [allOwnerData, setAllOwnerData] = useState([]);
    const [selectValue, setSelectValue] = useState([]);
    const [dropMenu, setDropMenu] = useState(false);
    const [searchOwner, setSearchOwner] = useState([]);
    const [searchText, setSearchText] = useState("");

    // multi dropdown ----------
    const dropdownMenuOpen = () => {
        setDropMenu(!dropMenu);
        if (!dropMenu) {
            document.getElementById("myText").focus();
        }
    };

    const handleClickOption = (e) => {
        let a = [];
        var index = a.findIndex((x) => x._id === e._id);
        if (index === -1) {
            a.push(e);
        } else {
            var num = a.indexOf(e);
            if (num > -1) {
                a.splice(num, 1);
            }
        }
        setSelectValue(a);
        setOwnerSelect(a[0]._id);
    };
    const onImageChangeOne = (event) => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            setImageOne(URL.createObjectURL(img));
            setHubImg(img);
            if (isSubmitted) valid();
        }
    };

    const onImageChangeTwo = (event) => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            setImageTwo(URL.createObjectURL(img));
            setAddvertiseImg(img);
            if (isSubmitted) valid();
        }
    };

    const handleSearch = async (type, txt) => {
        setSearchText(txt.target.value);
        try {
            const search = await allSearch(type, encodeURIComponent(txt.target.value));
            let dataValue = search.data.data;
            setSearchOwner(dataValue);
        } catch (ex) {
            console.log(ex);
        }
    };

    // validations
    const valid = () => {
        let checked = true;
        if (ownerSelect === "") {
            checked = false;
        }
        if (imageOne === null) {
            checked = false;
        }
        if (imageTwo === null) {
            checked = false;
        }
        if (hubName === "") {
            checked = false;
        }
        if (fssaiNo === "") {
            checked = false;
        }
        if (landmark === "") {
            checked = false;
        }
        if (description === "") {
            checked = false;
        }
        if (phoneNo?.length < 10) {
            checked = false;
        }
        if (locality === "") {
            checked = false;
        }
        if (hubAddress === "") {
            checked = false;
        }
        if (addMapLat === "") {
            checked = false;
        }
        if (addMapLong === "") {
            checked = false;
        }
        if (openTime.format("HH:mm")?.length < 4) {
            checked = false;
        }
        if (closeTime.format("HH:mm")?.length < 4) {
            checked = false;
        }
        if (breakStart.format("HH:mm")?.length < 4) {
            checked = false;
        }
        if (breakEnd.format("HH:mm")?.length < 4) {
            checked = false;
        }
        if (pinNo?.length !== 6) {
            checked = false;
        }
        if (startTime.format("HH:mm")?.length < 4) {
            checked = false;
        }
        if (endTime.format("HH:mm")?.length < 4) {
            checked = false;
        }
        if (headerText === "") {
            checked = false;
        }
        if (footerText === "") {
            checked = false;
        }
        return checked;
    };

    // api call---
    const updateHubImg = async (hubId) => {
        try {
            if (hubImg !== null) {
                const outImg = await uploadImage(hubImg, "hubs");
                console.log("   De_Hub_images: ", outImg.data.data.location);
                if (addvertiseImg !== null) {
                    const adImg = await uploadImage(addvertiseImg, "hubs");
                    const data = {
                        De_Hub_images: outImg.data.data.location,
                        advertise_image: adImg.data.data.location,
                    };
                    const dataImage = await UpdateDeHubImage(hubId, data);
                } else {
                    const data = {
                        De_Hub_images: outImg.data.data.location,
                    };
                    const dataImage = await UpdateDeHubImage(hubId, data);
                }
            } else if (addvertiseImg !== null) {
                const adImg = await uploadImage(addvertiseImg, "hubs");
                const data = {
                    advertise_image: adImg.data.data.location,
                };
                const dataImage = await UpdateDeHubImage(hubId, data);
            }
            store.dispatch(loader(false));
        } catch (ex) {
            ToastError(ex.response.data.msg);
            store.dispatch(loader(false));
        }
    };

    const newHub = () => {
        store.dispatch(loader(true));
        const data = {
            owner: ownerSelect,
            brand_name: brandName,
            hub_name: hubName,
            phone: phoneNo,
            locality: locality,
            description: description,
            FSSAI_no: fssaiNo,
            address_details: {
                address: hubAddress,
                lat: addMapLat,
                long: addMapLong,
                pincode: pinNo,
                landmark: landmark,
            },
            GST_number: gstNo,
            licence_number: licenceNo,
            opening_time: openTime.format("HH:mm"),
            closing_time: closeTime.format("HH:mm"),
            break_start: breakStart.format("HH:mm"),
            break_end: breakEnd.format("HH:mm"),
            delivery_start_time: startTime.format("HH:mm"),
            delivery_end_time: endTime.format("HH:mm"),
            bill_header_text: headerText,
            bill_footer_text: footerText,
        };
        if (isUpdate) {
            UpdateDeHub(hubId, data)
                .then(function (response) {
                    updateHubImg(hubId);
                    store.dispatch(loader(false));
                    ToastSuccess(response.data.msg);
                    props.history.goBack();
                })
                .catch(function (error) {
                    console.log(error);
                    ToastError(error.response.data.msg);
                    store.dispatch(loader(false));
                });
        } else {
            CreateDeHub(data)
                .then(function (response) {
                    updateHubImg(response.data.data._id);
                    store.dispatch(loader(false));
                    ToastSuccess(response.data.msg);
                    props.history.goBack();
                })
                .catch(function (error) {
                    ToastError(error.response.data.msg);
                    console.log(error);
                    store.dispatch(loader(false));
                });
        }
    };
    const fetchSingleDeHubDetails = async (hubId) => {
        try {
            const response = await GetSingleDeHub(hubId);
            if (response.status === 200) setSingleDeHubDetails(response.data?.data);
            else { ToastError(response.data?.msg) };
        } catch (error) {
            console.error(error?.response?.data?.error);
            ToastError(error?.response?.data?.msg)
        }
    }
    const submited = () => {
        setIsSubmitted(true);
        if (valid()) {
            newHub();
        }
    };

    useEffect(() => {
        getOwner(1)
            .then(function (response) {
                setAllOwnerData(response.data.data);
            });
    }, []);

    useEffect(() => {
        if (hubId) {
            fetchSingleDeHubDetails(hubId);
            setIsUpdate(true)
        }
    }, [hubId]);
    useEffect(() => {
        if (singleDeHubDetails) {
            setImageOne(singleDeHubDetails.De_Hub_images);
            setImageTwo(singleDeHubDetails.advertise_image);
            setOwnerSelect(singleDeHubDetails.owner);
            setBrandName(singleDeHubDetails.brand_name);
            setHubName(singleDeHubDetails.hub_name);
            setPhoneNo(singleDeHubDetails.phone);
            setLocality(singleDeHubDetails.locality);
            setDescription(singleDeHubDetails.description);
            setFssaiNo(singleDeHubDetails.FSSAI_no);
            setHubAddress(singleDeHubDetails.address_details?.address);
            setAddMapLat(singleDeHubDetails.address_details?.lat);
            setAddMapLong(singleDeHubDetails.address_details?.long);
            setPinNo(singleDeHubDetails.address_details?.pincode);
            setLandmark(singleDeHubDetails.address_details?.landmark);
            setGstNo(singleDeHubDetails.GST_number);
            setLicenceNo(singleDeHubDetails.licence_number);
            setOpenTime(moment(singleDeHubDetails.opening_time, "HH:mm"));
            setCloseTime(moment(singleDeHubDetails.closing_time, "HH:mm"));
            setBreakStart(moment(singleDeHubDetails.break_start, "HH:mm"));
            setBreakEnd(moment(singleDeHubDetails.break_end, "HH:mm"));
            setStartTime(moment(singleDeHubDetails.delivery_start_time, "HH:mm"));
            setEndTime(moment(singleDeHubDetails.delivery_end_time, "HH:mm"));
            setHeaderText(singleDeHubDetails.bill_header_text);
            setFooterText(singleDeHubDetails.bill_footer_text);
        }
    }, [singleDeHubDetails]);
    return (
        <>
            <div className="my-3">
                <button onClick={() => submited()} type="button" className="btn btn-verify">{hubId ? "Update" : "Add"} Hub</button>
                <button type="button" onClick={() => props.history.goBack()} className="btn btn-cancel">Cancel</button>
            </div>
            <div className="container-fluid add-user-container py-3">
                <u><h5 className="mt-4 mb-3">New Hub Registration:</h5></u>
                <div className="row">
                    <div className="col-sm-3">
                        <div className="form-group">
                            <label className="font-12 m-0">Select Owner:</label>
                            <div className="select-box">
                                <div className="options-container" style={dropMenu ? {} : { display: "none" }}>
                                    {searchText === ""
                                        ? allOwnerData.map((item, i) => {
                                            return (
                                                <div className="option" key={item._id} onClick={() => handleClickOption(item)}>
                                                    <label>{item.full_name}</label>
                                                </div>
                                            );
                                        })
                                        : searchOwner &&
                                        searchOwner.map((item, i) => {
                                            return (
                                                <div className="option" key={item._id} onClick={() => handleClickOption(item)}>
                                                    <label>{item.full_name}:</label>
                                                </div>
                                            );
                                        })}
                                </div>
                                <div className="selected" onClick={dropdownMenuOpen}>
                                    {(dropMenu && selectValue?.length) >= 1 || (!dropMenu && selectValue?.length) >= 1 ? "" : "Select Owner"}
                                    {selectValue.map((m, i) => {
                                        return (
                                            <span className="badge bg-warning text-dark mx-1" key={i}>
                                                {m.full_name}
                                            </span>
                                        );
                                    })}
                                </div>
                                <div className="search-box" style={dropMenu ? {} : { display: "none" }}>
                                    <input onChange={(e) => handleSearch("owner", e)} id="myText" type="search" placeholder="Search ..." autoComplete="off" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={!ownerSelect ? "col-sm-3" : "col-sm-3"}>
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Hub Name:</label>
                            <input onChange={(e) => { setHubName(e.target.value); if (isSubmitted) valid(); }} style={hubName === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={hubName} className="form-control" placeholder="Hub Name" id="usr1" />
                        </div>
                        <p className="error-msg">
                            {hubName === "" && isSubmitted ? "Please enter hub name" : ""}
                        </p>
                    </div>
                    <div className={!ownerSelect ? "col-sm-3" : "col-sm-3"}>
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Brand Name:</label>
                            <input onChange={(e) => setBrandName(e.target.value)} type="text" value={brandName} className="form-control" placeholder="Brand Name" id="usr1" />
                        </div>
                    </div>
                    <div className={!ownerSelect ? "col-sm-3" : "col-sm-3"}>
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Pin No:</label>
                            <input onChange={(e) => { setPinNo(e.target.value); if (isSubmitted) valid() }} style={pinNo?.length !== 6 && isSubmitted ? { border: "1px solid red" } : {}} type="number" value={pinNo} className="form-control" placeholder="PIN no" id="usr9" />
                        </div>
                        <p className="error-msg">
                            {pinNo?.length !== 6 && isSubmitted ? "Enter pin no" : ""}
                        </p>
                    </div>
                    <div className={!ownerSelect ? "col-sm-3" : "col-sm-3"}>
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Landmark:</label>
                            <input onChange={(e) => { setLandmark(e.target.value); if (isSubmitted) valid(); }} style={landmark === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={landmark} className="form-control" placeholder="Landmark" id="usr4" />
                        </div>
                        <p className="error-msg">
                            {landmark === "" && isSubmitted ? "Please enter landmark" : ""}
                        </p>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Phone No:</label>
                            <input type="number" value={phoneNo} onChange={(e) => { const input = e.target.value; if (/^\d{0,10}$/.test(input)) { setPhoneNo(input); } if (isSubmitted) valid(); }} style={phoneNo?.length !== 10 && isSubmitted ? { border: "1px solid red" } : {}} className="form-control" placeholder="Phone no" />
                        </div>
                        <p className="error-msg">
                            {phoneNo?.length !== 10 && isSubmitted ? "Enter your ph no" : ""}
                        </p>
                    </div>

                    <div className="col-sm-3">
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Locality:</label>
                            <input onChange={(e) => { setLocality(e.target.value); if (isSubmitted) valid(); }} style={locality === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={locality} className="form-control" placeholder="Locality" />
                        </div>
                        <p className="error-msg">
                            {locality === "" && isSubmitted ? "Enter your locality" : ""}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Descriptions:</label>
                            <textarea onChange={(e) => { setDescription(e.target.value); if (isSubmitted) valid(); }} style={description === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={description} className="form-control" placeholder="Descriptions" rows={4} />
                        </div>
                        <p className="error-msg">
                            {description === "" && isSubmitted ? "Enter description" : ""}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Hub's Address:</label>
                            <input onChange={(e) => { setHubAddress(e.target.value); if (isSubmitted) valid(); }} style={hubAddress === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={hubAddress} className="form-control" placeholder="Hub's Address" id="usr5" />
                        </div>
                        <p className="error-msg">
                            {hubAddress === "" && isSubmitted ? "Please enter address" : ""}
                        </p>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Latitude:</label>
                            <input onChange={(e) => { setAddMapLat(e.target.value); if (isSubmitted) valid(); }} style={addMapLat === "" && isSubmitted ? { border: "1px solid red" } : {}} type="number" value={addMapLat} className="form-control" placeholder="Lat" />
                        </div>
                        <p className="error-msg">
                            {addMapLat === "" && isSubmitted ? "Please enter lat" : ""}
                        </p>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0">Longitude:</label>
                            <input onChange={(e) => { setAddMapLong(e.target.value); if (isSubmitted) valid(); }} style={addMapLong === "" && isSubmitted ? { border: "1px solid red" } : {}} type="number" value={addMapLong} className="form-control" placeholder="Long" id="usr6" />
                        </div>
                        <p className="error-msg">
                            {addMapLong === "" && isSubmitted ? "Please enter long" : ""}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr3">GST number:</label>
                            <input onChange={(e) => { setGstNo(e.target.value); if (isSubmitted) valid(); }} type="text" value={gstNo} className="form-control" placeholder="GST Number" id="usr3" />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr2">FSSAI no:</label>
                            <input onChange={(e) => { setFssaiNo(e.target.value); if (isSubmitted) valid(); }} style={fssaiNo === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={fssaiNo} className="form-control" placeholder="FSSAI No." id="usr2" />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr2">Licence no:</label>
                            <input onChange={(e) => { setLicenceNo(e.target.value); if (isSubmitted) valid(); }} style={licenceNo === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={licenceNo} className="form-control" placeholder="Licence No." id="usr2" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="hub-open-time">Hub Opening Time:</label>
                            <TimePicker value={openTime} onChange={(time) => { setOpenTime(time); if (isSubmitted) valid(); }} placeholder="HH:MM" use12Hours={false} showSecond={false} format="HH:mm" />
                        </div>
                    </div>

                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr8">Hub Closing Time:</label>
                            <TimePicker onChange={(time) => { setCloseTime(time); if (isSubmitted) valid(); }} placeholder="HH:MM" defaultValue={closeTime} value={closeTime} use12Hours={false} showSecond={false} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr7">Hub Break Time Start:</label>
                            <TimePicker onChange={(time) => { setBreakStart(time); if (isSubmitted) valid(); }} placeholder="HH:MM" defaultValue={breakStart} value={breakStart} use12Hours={false} showSecond={false} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr8">Hub Break Time End:</label>
                            <TimePicker onChange={(time) => { setBreakEnd(time); if (isSubmitted) valid(); }} placeholder="HH:MM" defaultValue={breakEnd} value={breakEnd} use12Hours={false} showSecond={false} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr10">Delivery Start Time:</label>
                            <TimePicker onChange={(time) => { setStartTime(time); if (isSubmitted) valid(); }} placeholder="HH:MM" defaultValue={startTime} value={startTime} use12Hours={false} showSecond={false} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr11">Delivery End Time:</label>
                            <TimePicker onChange={(time) => { setEndTime(time); if (isSubmitted) valid(); }} placeholder="HH:MM" defaultValue={endTime} value={endTime} use12Hours={false} showSecond={false} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr15">Bill Header Text:</label>
                            <input onChange={(e) => { setHeaderText(e.target.value); if (isSubmitted) valid(); }} style={headerText === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={headerText} className="form-control" id="usr15" />
                        </div>
                        <div className="form-group m-0">
                            <label className="font-12 m-0" htmlFor="usr16">Bill Footer Text:</label>
                            <input onChange={(e) => { setFooterText(e.target.value); if (isSubmitted) valid(); }} style={footerText === "" && isSubmitted ? { border: "1px solid red" } : {}} type="text" value={footerText} className="form-control" id="usr16" />
                        </div>
                    </div>
                    <div className="col-sm-3 col-12">
                        <div className="new-outlet-image-container">
                            <div>
                                <label>Hub image:</label>
                                <label className="upload-image-container cursor-pointer" htmlFor="file">
                                    <img src={imageOne} alt="" style={imageOne === null && isSubmitted ? { border: "1px solid red" } : {}} className="upload-image" />
                                    <i style={imageOne !== null ? { color: "transparent" } : {}} className="demo-icon icon-camera">&#xe807;</i>
                                    <input type="file" id="file" accept="image/*" onChange={(e) => onImageChangeOne(e)} />
                                    :</label>
                            </div>
                            <div>
                                <div>
                                    <label>Ad image:</label>
                                    <label className="upload-image-container cursor-pointer" htmlFor="file2">
                                        <img src={imageTwo} alt="" style={imageTwo === null && isSubmitted ? { border: "1px solid red" } : {}} className="upload-image" />
                                        <i style={imageTwo !== null ? { color: "transparent" } : {}} className="demo-icon icon-camera">&#xe807;</i>
                                        <input type="file" id="file2" accept="image/*" onChange={(e) => onImageChangeTwo(e)} />
                                        :</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};
export default connect(mapStateToProps)(DeHubForm);